import Naja from 'naja';
import Nette from 'nette-forms';
import NetteTools from 'utils/nette-tools/nette.tools';
import Bootstrap from 'bootstrap.native';
import ExtensionLoader from 'utils/ExtensionLoader';
//import {GridExtension} from 'vendor/quextum/entity-grid/client/EntityGrid';
import {GridExtension} from './EntityGrid';

const YOUTUBE_EMBED = 'https://www.youtube.com/embed/';
/**
 * @property {Naja} naja
 */
export default class ApplicationExtension {
	/** @type {Naja} */
	naja = null;
	/** @type {string|null} */
	lang = null;
	/** @type {string|null} */
	locale = null;

	constructor(naja) {
		this.naja = naja;
		naja.addEventListener('load', this.load.bind(this));
		naja.addEventListener('init', this.init.bind(this));
		naja.addEventListener('before', this.before.bind(this));
		naja.addEventListener('interaction', this.interaction.bind(this));
	}

	init() {
		this.locale = document.documentElement.lang;
		[this.lang] = this.locale.split('_');
	}

	before({url, options}) {
		if (url.includes('do='))
			options.history = false;
	}

	interaction(event) {
		const {element} = event;
		if (element.dataset.confirm && !confirm(element.dataset.confirm)) {
			event.preventDefault();
			return false;
		}
	}

	initSortables(Sortable) {
		const {naja} = this;
		for (let e of document.querySelectorAll('[data-sortable]')) {
			Sortable.create(e, {
				group: e.dataset.sortableGroup | 'root',
				chosenClass: 'bg-primary',
				draggable: '.sortable-item',
				handle: '.sortable-handle',
				onUpdate(event) {
					naja.makeRequest('POST', e.dataset.sortable, NetteTools.componentParams(e.dataset.control, {
						from: event.from.dataset.sortableGroup || 0,
						to: event.to.dataset.sortableGroup || 0,
						id: event.item.dataset.id,
						order: this.toArray(),
					}), {history: false, element: event.target});

				}
			});
		}
	}

	load() {
		Bootstrap.initCallback();
		for (let e of document.querySelectorAll('.dropdown-checkbox-list')) {
			e.addEventListener('click',(e)=>{
				e.stopPropagation();
				return false;
			});
		}
		/** Data mask, used for dates, zip codes etc. */
		/** Bootstrap tooltip */
		for (let e of document.querySelectorAll('[title]')) {
			new Bootstrap.Tooltip(e, {
				trigger: 'hover',
				container: e.closest('body')
			})
		}

		for (let e of document.querySelectorAll('[data-show]')) {
			e.addEventListener('click', ()=> {
				for (let f of document.querySelectorAll(e.getAttribute('data-show'))) {
					f.classList.add('show');
				}
			});
		}

		for (let e of document.querySelectorAll('[data-transform="webalize"]')) {
			let timeout;
			e.removeAttribute('data-transform');
			e.addEventListener('keyup', ()=> {
				clearTimeout(timeout);
				timeout = setTimeout(()=> {
					e.value = Nette.webalize(e.value.replace(/(<([^>]+)>)/ig,""));
				}, 300)
			});
		}

		for (let e of document.querySelectorAll('[data-toggle="popover"]'))new Bootstrap.Popover(e);
		for (let e of document.querySelectorAll('[data-youtube-embed]')) {
			const input = document.getElementById(e.dataset.youtubeEmbed);
			e.removeAttribute('data-youtube-embed');
			e.src = YOUTUBE_EMBED + input.value;
			input.addEventListener('change', ()=> e.src = YOUTUBE_EMBED + input.value);
		}
		for (let preview of document.querySelectorAll('[data-preview]')) {
			const input = document.getElementById(preview.dataset.preview);
			preview.removeAttribute('data-preview');
			if (preview.tagName.toLowerCase() === 'img') {
				input.addEventListener('change', ()=> {
					preview.src = input.files.length ? window.URL.createObjectURL(input.files[0]) : null;
				});
			} else {
				input.addEventListener('change', ()=> {
					while (preview.firstChild) preview.removeChild(preview.firstChild);
					for (let file of input.files) {
						const img = document.createElement('img');
						img.style.objectFit = 'cover';
						img.width = preview.dataset.width || 200;
						img.height = preview.dataset.height || 200;
						img.src = window.URL.createObjectURL(file);
						preview.appendChild(img);
					}
				});
			}
		}
		for (let label of document.querySelectorAll('.custom-file-label[for]')) {
			label.dataset.placeholder = label.innerHTML;
			const input = document.getElementById(label.htmlFor);
			input.addEventListener('change', (e) => {
				label.innerHTML = e.target.files.length ? Array.from(e.target.files).map((file)=>file.name).join(', ') : label.dataset.placeholder;
			});
		}
	}
}
const ext = new Map();
ext.set('[data-provide=datepicker]:not(.flatpickr-input)', ()=>import('./DatePickersExtension'));
ext.set('[data-mask]', ()=>import('./MaskExtension'));
ext.set('select,[data-select]', ()=>import('./SlimSelectExtension'));
ext.set('textarea[data-editor]', ()=>import('./TinyMceExtension'));

Naja.registerExtension(ApplicationExtension);
Naja.registerExtension(GridExtension);
Naja.registerExtension(ExtensionLoader, ext, {Nette,Bootstrap});
Naja.initialize();

